import { formatIsoToDateString } from "utils/formatting";

export const getExportBuildingsFileName = () => `buildings_${formatIsoToDateString(new Date().toISOString())}.csv`;
